function build(txt, img, tre) {
  let struttura = [];
  let temp;
  struttura.push(<h2 className="subtitle" id="h2"> {txt[0]}</h2>);
  temp = <div className="paragrafo">{txt[1]}</div>;
  struttura.push(temp);
  temp = <div className="paragrafo">{img[0]}</div>;
  struttura.push(temp);
  temp =
    <div className="paragrafo">
      {txt[2]}{img[1]}</div>;
  struttura.push(temp);
//castello
  temp = <h3 className="sottotitoli">{txt[3]}</h3>;
  struttura.push(temp);

  temp =
    <div className="paragrafo">
      {txt[4]}
      {img[2]}
    </div>
    ;
  struttura.push(temp);
  temp =
  <div className="paragrafo">
    {txt[5]}
  </div>
  ;
struttura.push(temp);
temp =
  <div className="paragrafo">
    {txt[6]}
  </div>
  ;
struttura.push(temp);
  temp =
  <div className="paragrafo">
    {img[3]}
    {txt[7]}
  </div>
  ;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[8]}
  {img[4]}
</div>
;
struttura.push(temp);
//torri fine
temp =
<div className="paragrafo">
  {txt[9]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {img[5]}
  {img[6]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[10]}
</div>
;
struttura.push(temp);
//fine prigioni
temp =
<div className="paragrafo">
  {txt[11]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {img[7]}
  {txt[12]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[13]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {img[8]}
  {img[9]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[14]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[15]}
  {img[10]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[16]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {img[11]}
  {img[12]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[17]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {img[13]}
  {txt[18]}
</div>
;
struttura.push(temp);

temp = <div className="paragrafo">{txt[19]}</div>;
struttura.push(temp);

temp = <h3 className="sottotitoli">{txt[20]}</h3>;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[21]}
  {img[14]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[22]}
  {img[15]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[23]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[24]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {img[16]}
  {img[17]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[25]}
</div>
;
struttura.push(temp);
//fine cattedrale
temp =
<div className="paragrafo">
  {txt[26]}
  {img[18]}
</div>
;
struttura.push(temp);

temp =
<div className="paragrafo">
  {txt[27]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {img[19]}
  {img[20]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[28]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[29]}
  {img[21]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[30]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {img[22]}
  {img[23]}
  {img[24]}
</div>
;
struttura.push(temp);
temp =
<div className="paragrafo">
  {txt[31]}
</div>
;
struttura.push(temp);

temp =<div className="note">{txt[32]}</div>;
struttura.push(temp);


  return struttura;
}

export default build;
